import { useState } from 'react';

const testimonials = [
  {
    id: 1,
    name: '田中様ご家族',
    location: '世田谷区',
    image: 'https://readdy.ai/api/search-image?query=Happy%20Japanese%20family%20portrait%20in%20modern%20home%20interior%20with%20soft%20studio%20lighting%2C%20warm%20and%20welcoming%20atmosphere%20with%20professional%20photography%20quality%2C%20satisfied%20homeowners%20with%20genuine%20smiles%20in%20contemporary%20living%20space%2C%20natural%20and%20authentic%20family%20photo%20with%20clean%20background%20and%20refined%20aesthetic%20composition&width=800&height=1000&seq=testimonial-001&orientation=portrait',
    quote: '担当の方が親身になって相談に乗ってくださり、家族全員が満足できる物件に出会えました。購入後のサポートも充実していて安心です。',
    title: '理想の家が見つかりました'
  },
  {
    id: 2,
    name: '佐藤様',
    location: '港区',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20businessman%20portrait%20in%20modern%20office%20setting%20with%20studio%20lighting%2C%20confident%20and%20satisfied%20client%20with%20genuine%20expression%2C%20high-quality%20professional%20headshot%20with%20clean%20background%20and%20sophisticated%20atmosphere%2C%20natural%20portrait%20photography%20with%20refined%20aesthetic%20and%20warm%20tones&width=800&height=1000&seq=testimonial-002&orientation=portrait',
    quote: '投資用物件を探していましたが、市場分析から購入後の管理まで、トータルでサポートしていただきました。プロフェッショナルな対応に感謝しています。',
    title: '信頼できるパートナー'
  },
  {
    id: 3,
    name: '山田様',
    location: '渋谷区',
    image: 'https://readdy.ai/api/search-image?query=Young%20Japanese%20couple%20portrait%20in%20modern%20apartment%20with%20soft%20natural%20lighting%2C%20happy%20homeowners%20with%20warm%20smiles%20in%20contemporary%20interior%20space%2C%20authentic%20and%20natural%20couple%20photography%20with%20clean%20background%2C%20professional%20portrait%20with%20refined%20aesthetic%20and%20welcoming%20atmosphere&width=800&height=1000&seq=testimonial-003&orientation=portrait',
    quote: '初めての不動産購入で不安でしたが、丁寧な説明と迅速な対応で安心して進めることができました。本当にありがとうございました。',
    title: '安心のサポート体制'
  }
];

export default function Testimonial() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const current = testimonials[currentIndex];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* Left Image */}
          <div className="lg:col-span-2">
            <div className="rounded-3xl overflow-hidden aspect-[3/4]">
              <img
                src={current.image}
                alt={current.name}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right Content */}
          <div className="lg:col-span-3 flex flex-col justify-center">
            <p className="text-sm text-gray-500 mb-4">（お客様の声）</p>
            
            <h2 className="text-5xl lg:text-6xl font-bold mb-8">
              <span className="text-gray-900">{current.title.substring(0, 6)}</span>
              <span className="text-gray-400">{current.title.substring(6)}</span>
            </h2>

            <blockquote className="text-gray-700 text-lg leading-relaxed mb-8">
              「{current.quote}」
            </blockquote>

            <p className="text-gray-900 font-bold text-lg mb-12">
              — {current.name}（{current.location}）
            </p>

            {/* Controls */}
            <div className="flex gap-4">
              <button
                onClick={handlePrev}
                className="w-12 h-12 rounded-full border-2 border-gray-300 flex items-center justify-center hover:border-gray-900 transition-colors cursor-pointer"
                aria-label="前へ"
              >
                <i className="ri-arrow-left-line text-gray-600 text-xl"></i>
              </button>
              <button
                onClick={handleNext}
                className="w-12 h-12 rounded-full bg-gray-900 flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer"
                aria-label="次へ"
              >
                <i className="ri-arrow-right-line text-white text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
